const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    color: theme.iconColor,
    backgroundColor: theme.ModalBGColor,
  },
  contentContainer: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  main: {
    fontSize: theme.textFontSize,
    alignContent: "flex-start",
    margin: 0,
    padding: "0 20 20 20",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "auto"
  },
  radioHeader: {
    paddingTop: "16px",
  },
  head: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    padding: "8px 24px",
    fontWeight: 600,
    flexBasis: "auto",
  },
  group: {
    padding: "12px 0",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
  },

  item: {
    lineHeight: "24px",
  },

  errorColor: {
    paddingBottom: 10,
    fontSize: 11,
    color: theme.ErrorMessageColor,
  },
  footer: {
    bottom: 0,
    padding: 20,
  },
  actionButton: {
    display: "flex",
    width: 140,
    textTransform: "none",
    "&$actionDisabled, &$actionDisabled:hover": {
      cursor: "not-allowed",
      pointerEvents: "all",
      backgroundColor: "transparent",
      opacity: 0.7,
      color: theme.TextColor,
      border: `1px solid ${theme.iconColor}`,
      "&$activeButton": {
        borderColor: theme.HeaderSelectedText,
      },
      "&$activePrimaryButton": {
        backgroundColor: theme.HeaderSelectedText,
        border: theme.HeaderSelectedText,
        color: "white",
      },
    },
  },
  activeButton: {},
  activePrimaryButton: {},
  actionDisabled: {},
  actionContained: {},
  divider: {
    backgroundColor: theme.AppBGColor,
  },

  showContent: {
    display: "block",
  },

  radio: {
    marginTop: "10px",
    padding: "0 12px",
    color: theme.iconColor,
    "&$radioDisabled": {
      color: theme.iconColor,
    },
  },
  radioLabel: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    paddingTop: "10px",
    "&$radioDisabled": {
      color: theme.iconColor,
    },
  },
  windowLabel: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    whiteSpace: "pre",
    paddingTop: "10px",
    "&$radioDisabled": {
      color: theme.iconColor,
    },
  },
  radioDisabled: {
    color: theme.iconColor,
  },
  radioGroup: {
    padding: "10px 0",
  },
  folder: {
    margin: "15px 0px",
  },
  mergeContainer: {
    display: "flex",
    flexDirection: "column",
    flex: "auto",
    overflow: "auto"
  }
});

export default styles;
